// import React, { useState, useEffect, useRef } from "react";
// import { Container, Row, Col, Form, Button, Table } from "react-bootstrap";
// import {
//   FaStar,
//   FaChevronDown,
//   FaChevronUp,
//   FaPhone,
//   FaEnvelope,
//   FaMapPin,
// } from "react-icons/fa";
// import "../../assets/css/allpackeges.css";
// import TourPackeges from "./TourPackeges";
// import TestimonialSlider from "../TestimonialSection/TestimonialSection";
// import Faq from "../FAQ/Faq";
// import { useLocation, useParams } from "react-router-dom";
// import axios from "axios";
// import BASE_URL from "../../component/commanfile";

// const AllPackages = () => {
//   const location = useLocation();
//   const params = useParams();
//   const id = params.id;
//   const data = location.state?.tourSectorId;
//   const [showFullDescription, setShowFullDescription] = useState(false);
//   const [showPackageTable, setShowPackageTable] = useState(false);
//   const [animateContent, setAnimateContent] = useState(false);
//   const [currentImageIndex, setCurrentImageIndex] = useState(0);
//   const [selectedSector, setSelectedSector] = useState([]);
//   const backgroundRef = useRef(null);
//   const [tourSector, setTourSector] = useState([]);

//   useEffect(() => {
//     const fetchTourSector = async () => {
//       try {
//         const response = await axios.get(`${BASE_URL}api/web-tours/web-tours-sectors-package/${id}`);
//         const data = response?.data || [];
//         setTourSector(data);

//       } catch (error) {
//         console.error("Error fetching packages:", error);
//       }
//     };

//     fetchTourSector();
//   }, [id]);

//   const tourData = selectedSector?.tours?.[0] || [];


//   const toggleDescription = () => {
//     setShowFullDescription(!showFullDescription);
//     if (!showFullDescription && !showPackageTable) {
//       setTimeout(() => {
//         setShowPackageTable(true);
//         setAnimateContent(true);
//       }, 300);
//     } else {
//       setAnimateContent(!animateContent);
//     }
//   };

//   const packages = [
//     {
//       name: "Women's Special Kashmir",
//       days: "5 Days",
//       price: "₹63,000",
//       featured: true,
//       highlights: ["All-women group", "Female guides", "Shopping excursions"],
//     },
//     {
//       name: "Kashmir Escape",
//       days: "5 Days",
//       price: "₹63,000",
//       featured: false,
//       highlights: ["Srinagar", "Gulmarg", "Pahalgam"],
//     },
//     {
//       name: "Women's Special Kashmir",
//       days: "6 Days",
//       price: "₹70,000",
//       featured: false,
//       highlights: ["Extended stay", "Sonmarg visit", "Craft workshops"],
//     },
//     {
//       name: "Seniors' Special Kashmir",
//       days: "6 Days",
//       price: "₹70,000",
//       featured: true,
//       highlights: [
//         "Relaxed pace",
//         "Medical assistance",
//         "Comfortable accommodations",
//       ],
//     },
//     {
//       name: "Honeymoon Special Kashmir - Pune",
//       days: "6 Days",
//       price: "₹71,000",
//       featured: true,
//       highlights: ["Romantic stays", "Private dinners", "Shikara rides"],
//     },
//   ];

//   return (
//     <>
//       <section className="tour-section"
//         style={{
//           backgroundImage: `url(${BASE_URL}/api/image?file=${encodeURIComponent(tourSector?.tour_package?.[0]?.thumbnail?.substring(1))})`
//         }}
//       >
//         <div className="parallax-background" ref={backgroundRef}></div>
//         <div className="parallax-overlay"></div>
//         <Container style={{ maxWidth: "1600px" }}>
//           <Row className="align-items-start">
//             <Col lg={8} md={7} sm={12}>
//               <div className="tour-content">
//                 <h1 className="tour-heading">
//                   {tourSector?.tour_package?.[0]?.tour_sector_name} Tour Packages
//                 </h1>
//                 <div className="tour-rating">
//                   <span className="stars">
//                     {[...Array(5)].map((_, i) => (
//                       <FaStar key={i} />
//                     ))}
//                   </span>
//                   <span className="rating-text">
//                     1.7K+ guests rated 5* | 1,676 Reviews
//                   </span>
//                 </div>

//                 <div className="tour-description-container">
//                   <p className="tour-description">
//                     <strong>
//                       The Land that many call to experience India's Crown &amp;
//                       Earth's Paradise, indeed!
//                     </strong>
//                     <br />
//                     Rightly known as the 'Crown of India', the state of Jammu
//                     &amp; Kashmir indeed lives up to its nickname of being the
//                     'Paradise on Earth'. As quoted by the Mughal Emperor
//                     Jehangir, "If there is heaven on earth, it's here, it's
//                     here, it's here". Jammu &amp; Kashmir casts a spell on
//                     everyone who visits here. It's a dream of every Indian
//                     traveller to visit this paradise, at least once.
//                   </p>

//                   <div
//                     className={`expanded-content ${showFullDescription ? "show" : ""
//                       }`}
//                   >
//                     {showFullDescription && (
//                       <p className="tour-description-full">
//                         Enchanting Chinar trees, bewitching thick deodar
//                         forests, beautiful apple orchards, stunning saffron
//                         fields, majestic snow-clad mountains, adorable Shikaras,
//                         iconic Houseboats, colourful Tulips in spring,
//                         spectacular snow-heaven Gulmarg, stunning Solang, and
//                         the list is never ending. Jammu &amp; Kashmir break you
//                         free, and the pristine Dal Lake gives you the unique
//                         experience of living in a houseboat. Explore the magical
//                         Mughal gardens, the vibrant culture of Srinagar, and the
//                         rich history of the region. Radhe Shyam World encourages
//                         you to make the most fascinating memories with us and
//                         relish our legacy to travel, explore, and celebrate
//                         life.
//                       </p>
//                     )}

//                     {showPackageTable && (
//                       <div
//                         className={`package-table-container ${animateContent ? "animate-in" : ""
//                           }`}
//                       >
//                         <h3 className="section-subtitle">
//                           Available Tour Packages
//                         </h3>


//                         <div className="package-highlights">
//                           <Row>
//                             {packages
//                               .filter((pkg) => pkg.featured)
//                               .map((pkg, index) => (
//                                 <Col md={4} key={index}>
//                                   <div
//                                     className={`highlight-card ${animateContent ? "animate-in" : ""
//                                       }`}
//                                     style={{
//                                       animationDelay: `${index * 0.1 + 0.2}s`,
//                                     }}
//                                   >
//                                     <h4>{pkg.name}</h4>
//                                     <div className="highlight-price">
//                                       {pkg.price}
//                                     </div>
//                                     <div className="highlight-duration">
//                                       {pkg.days}
//                                     </div>
//                                     <ul className="highlight-list">
//                                       {pkg.highlights.map((highlight, i) => (
//                                         <li key={i}>{highlight}</li>
//                                       ))}
//                                     </ul>
//                                     <Button className="highlight-btn" >
//                                       Enquiry Now
//                                     </Button>
//                                   </div>
//                                 </Col>
//                               ))}
//                           </Row>
//                         </div>
//                       </div>
//                     )}
//                   </div>

//                   <Button
//                     variant="link"
//                     onClick={toggleDescription}
//                     className="toggle-btn"
//                   >
//                     {showFullDescription ? (
//                       <>
//                         Read Less <FaChevronUp className="toggle-icon" />
//                       </>
//                     ) : (
//                       <>
//                         Read More <FaChevronDown className="toggle-icon" />
//                       </>
//                     )}
//                   </Button>
//                 </div>
//               </div>
//             </Col>

//             <Col lg={4} md={5} sm={12}>
//               <div className="form-card">
//                 <div className="form-header">
//                   <h5>Want us to call you?</h5>
//                   <p>Get personalized travel advice</p>
//                 </div>
//                 <Form>
//                   <Form.Group className="mb-3">
//                     <Form.Label>Full Name*</Form.Label>
//                     <Form.Control type="text" placeholder="Your name" />
//                   </Form.Group>

//                   <Form.Group className="mb-3">
//                     <Form.Label>Phone Number*</Form.Label>
//                     <div className="phone-input-group">
//                       <Form.Select className="country-code">
//                         <option>+91</option>
//                         <option>+1</option>
//                         <option>+44</option>
//                       </Form.Select>
//                       <Form.Control
//                         type="text"
//                         placeholder="Your phone number"
//                         className="phone-input"
//                       />
//                     </div>
//                   </Form.Group>

//                   <Button className="btn-callback w-100">
//                     Request Call Back
//                   </Button>
//                 </Form>
//               </div>

//             </Col>
//             <Col lg={12} md={12} sm={12}>

//               <div className="assistance-card">
//                 <h5>Looking for assistance?</h5>
//                 <div className="contact-info" >
//                   <div className="contact-itemmsss">
//                     <FaPhone className="contact-icon" />
//                     <span>1800 22 7979</span>
//                   </div>
//                   <div className="contact-itemmsss"
//                     style={{
//                       display: "flex",
//                       justifyContent: 'center'
//                     }}
//                   >
//                     <FaEnvelope className="contact-icon" />
//                     <a href="mailto:travel@RadheShyamworld.com">
//                       travel@RadheShyamworld.com
//                     </a>
//                   </div>
//                   <div className="contact-itemmsss"
//                     style={{
//                       display: "flex",
//                       justifyContent: 'end'
//                     }}>
//                     <FaMapPin className="contact-icon" />
//                     <a href="#">Locate nearest Radhe Shyam World</a>
//                   </div>
//                 </div>
//               </div>
//             </Col>

//           </Row>
//         </Container>
//       </section>

//       <section>
//         <TourPackeges tourSectorDetails={tourSector} id={id}/>
//       </section>
//       <section>
//         <TestimonialSlider />
//       </section>
//       <section>
//         <Faq />
//       </section>
//     </>
//   );
// };

// export default AllPackages;
// import React, { useState, useEffect, useRef } from "react";


// import { Container, Row, Col, Form, Button, Badge } from "react-bootstrap";
// import React, { useState, useEffect } from "react";
// import {
//   FaPhoneAlt,
//   FaEnvelope,
//   FaMapMarkerAlt
// } from "react-icons/fa";
// import "../../assets/css/allpackeges.css";
// import TourPackeges from "./TourPackeges";
// import { useParams } from "react-router-dom";
// import axios from "axios";
// import BASE_URL from "../../component/commanfile";

// const AllPackages = ({webdata}) => {
//   const { id } = useParams();
//   const [tourSector, setTourSector] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [data, setData] = useState([]);
//   const office = webdata?.ourOffice?.[0] || {};
//   const [heroThumbnail, setHeroThumbnail] = useState(null);
//   const [hero, setHero] = useState(null);


//   useEffect(() => {
//     const fetchTourSector = async () => {
//       try {
//         const response = await axios.get(
//           `${BASE_URL}api/web-tours/web-tours-sectors-package/${id}`
//         );
//         setTourSector(response?.data);
//       } catch (error) {
//         console.error("Error fetching packages:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchTourSector();
 
//   }, [id]);

// console.log("tourSector=", tourSector);

//   const styles = {
//     heroSection: {
//       position: "relative",
//       padding: "120px 0 80px",
//       backgroundImage: heroThumbnail
//         ? `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.7)), url(${BASE_URL}/api/image?file=${encodeURIComponent(
//             heroThumbnail.substring(1)
//           )})`
//         : "linear-gradient(45deg, #1a1a1a, #8f0909)",
//       backgroundSize: "cover",
//       backgroundPosition: "center",
//       backgroundAttachment: "fixed",
//       color: "#fff",
//       borderRadius: "0 0 50px 50px",
//     },
//     glassCard: {
//       background: "rgba(255, 255, 255, 0.95)",
//       backdropFilter: "blur(10px)",
//       borderRadius: "24px",
//       padding: "30px",
//       border: "1px solid rgba(255,255,255,0.3)",
//       boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
//       color: "#333",
//     },
//   };

//   if (loading)
//     return <div className="text-center py-5">Loading Paradise...</div>;

//   return (
//     <div className="modern-all-packages-page">
//       {/* 1. HERO SECTION */}
//       {/* <section style={styles.heroSection}>
//         <Container>
//           <Row className="gy-5 align-items-center">
//             <Col lg={10}>
//               <Badge
//                 bg="warning"
//                 text="dark"
//                 className="mb-3 px-3 py-2 text-uppercase fw-bold"
//               >
//                 Best Seller
//               </Badge>
//               <h1 className="display-3 fw-bold mb-3">
//                 {hero?.tour_sector_name || "Tour"}{" "}
//                 <span style={{ color: "#8f0909" }}> Discovery</span>
//               </h1>

//               <div className="description-box" style={{ maxWidth: "900px" }}>
//                 <p className="lead opacity-90">
//                   {hero?.description || ""}
//                 </p>

//                 {showFullDescription && (
//                   <p className="animate__animated animate__fadeIn">
//                     Enchanting Chinar trees, iconic Houseboats, and spectacular
//                     snow-heavens await. Our legacy is to help you explore,
//                     celebrate, and create memories that last a lifetime.
//                   </p>
//                 )}

//                 <Button
//                   variant="outline-light"
//                   className="rounded-pill px-4 mt-2"
//                   onClick={() =>
//                     setShowFullDescription(!showFullDescription)
//                   }
//                 >
//                   {showFullDescription ? "Read Less" : "Explore More Details"}
//                 </Button>
//               </div>
//             </Col>
//           </Row>
//         </Container>
//       </section> */}

//       {/* 3. ASSISTANCE BAR */}
//       <div className="assistance-strip py-4 bg-white border-bottom">
//         <Container>
//           <Row className="text-center gy-3">
//             <Col md={6} className="border-end border-md-none">
//               <div className="d-flex align-items-center justify-content-center">
//                 <FaPhoneAlt className="text-danger me-2" />
//                 <div>
//                   <div className="small text-muted">Call Us</div>
//                   <div className="fw-bold">{office.phone?.split('|')[0]}</div>
//                 </div>
//               </div>
//             </Col>
//             <Col md={6} className="border-md-none">
//               <div className="d-flex align-items-center justify-content-center">
//                 <FaEnvelope className="text-danger me-2" />
//                 <div>
//                   <div className="small text-muted">Email Us</div>
//                   <div className="fw-bold">{office.email?.split('|')[0]}</div>
//                 </div>
//               </div>
//             </Col>
           
//           </Row>
//         </Container>
//       </div>

//       {/* 4. PACKAGES GRID SECTION */}
//       <section className="bg-light">
//         <div className="tour-grid-wrapper">
//           <TourPackeges
//             tourSectorDetails={tourSector}
//             id={id}
//             data={data}
//             setData={setData}
//             setHeroThumbnail={setHeroThumbnail}
//             setHero={setHero}
//           />
//         </div>
//       </section>
//     </div>
//   );
// };

// export default AllPackages;



import { Container, Row, Col, Badge } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import "../../assets/css/allpackeges.css";
import TourPackeges from "./TourPackeges";
import { useParams } from "react-router-dom";
import axios from "axios";
import BASE_URL from "../../component/commanfile";

const AllPackages = ({ webdata }) => {
  const { id } = useParams();
  const [tourSector, setTourSector] = useState(null);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [heroThumbnail, setHeroThumbnail] = useState(null);
  const [hero, setHero] = useState(null);

  // Stable reference — avoids re-deriving on every render
  const office = webdata?.ourOffice?.[0] ?? {};
  const phone = office.phone?.split("|")[0];
  const email = office.email?.split("|")[0];

  useEffect(() => {
    let cancelled = false; // prevent state update on unmounted component

    const fetchTourSector = async () => {
      try {
        const { data: responseData } = await axios.get(
          `${BASE_URL}api/web-tours/web-tours-sectors-package/${id}`
        );
        if (!cancelled) setTourSector(responseData);
      } catch (error) {
        console.error("Error fetching packages:", error);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchTourSector();
    return () => { cancelled = true; };
  }, [id]); // only re-fetch when id changes

    console.log("tour_package_type-----111", tourSector);
  if (loading) return <div className="text-center py-5">Loading Paradise...</div>;

  return (
    <div className="modern-all-packages-page">

      {/* ASSISTANCE BAR */}
      <div className="assistance-strip py-4 bg-white border-bottom">
      <Container>
  <Row className="gy-3">

    <Col xs={12} md={6} className="border-md-end pb-3 pb-md-0">
      <div className="d-flex align-items-center justify-content-start justify-content-md-center">

        <div className="d-flex align-items-center justify-content-center me-3"
             style={{ width: "40px", height: "40px", flexShrink: 0 }}>
          <FaPhoneAlt className="text-danger fs-5" />
        </div>

        <div>
          <div className="small text-muted">Call Us</div>
          <div className="fw-bold">{phone}</div>
        </div>

      </div>
    </Col>

    <Col xs={12} md={6}>
      <div className="d-flex align-items-center justify-content-start justify-content-md-center">

        <div className="d-flex align-items-center justify-content-center me-3"
             style={{ width: "40px", height: "40px", flexShrink: 0 }}>
          <FaEnvelope className="text-danger fs-5" />
        </div>

        <div>
          <div className="small text-muted">Email Us</div>
          <div className="fw-bold">{email}</div>
        </div>

      </div>
    </Col>

  </Row>
</Container>
      </div>

      {/* PACKAGES GRID SECTION */}
      <section className="bg-light">
        <div className="tour-grid-wrapper">
          <TourPackeges
            tourSectorDetails={tourSector}
            id={id}
            data={data}
            setData={setData}
            setHeroThumbnail={setHeroThumbnail}
            setHero={setHero}
          />
        </div>
      </section>
    </div>
  );
};

export default AllPackages;

